// App modules a senior can hide per crew member per yacht (HR → Access tab).
// key = backend module key, path = frontend route prefix it guards.
export const APP_MODULES = [
  { key: "messages", label: "Messages", path: "/app/messages" },
  { key: "yachts", label: "Yachts", path: "/app/yachts" },
  { key: "crew", label: "Crew & network", path: "/app/crew" },
  { key: "talent", label: "Talent pool", path: "/app/talent" },
  { key: "inventory", label: "Inventory", path: "/app/inventory" },
  { key: "tasks", label: "Tasks", path: "/app/tasks" },
  { key: "calendar", label: "Calendar", path: "/app/calendar" },
  { key: "routines", label: "Periodic tasks", path: "/app/maintenance" },
  { key: "checklists", label: "Checklists", path: "/app/checklists" },
  { key: "logbook", label: "Logbook", path: "/app/logbook" },
  { key: "pettycash", label: "Petty Cash", path: "/app/petty-cash" },
  { key: "invoices", label: "Invoices", path: "/app/invoices" },
  { key: "documents", label: "Documents", path: "/app/documents" },
  { key: "media", label: "Media", path: "/app/photos" },
  { key: "reports", label: "Reports", path: "/app/reports" },
  { key: "marketplace", label: "Marketplace", path: "/app/marketplace" },
];

export const moduleForPath = (pathname) => {
  const hit = APP_MODULES.find(
    (m) => pathname === m.path || pathname.startsWith(`${m.path}/`),
  );
  return hit ? hit.key : null;
};
